const CHUNK_RELOAD_STORAGE_KEY = "critter:chunk-load-reload";
const CHUNK_RELOAD_RETRY_WINDOW_MS = 5 * 60 * 1000;
const CHUNK_LOAD_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /loading chunk \d+ failed/i,
  /chunkloaderror/i,
];

function messageFromUnknown(value) {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (value instanceof Error) return value.message || value.name || "";
  if (typeof value.message === "string") return value.message;
  if (typeof value.reason === "string") return value.reason;
  return "";
}

function readLastReload() {
  try {
    const raw = window.sessionStorage?.getItem(CHUNK_RELOAD_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeLastReload(payload) {
  try {
    window.sessionStorage?.setItem(CHUNK_RELOAD_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // Storage can be disabled; the in-memory navigation still recovers the current failure.
  }
}

function dispatchRecoveryToast(message) {
  window.dispatchEvent(
    new CustomEvent("critter-toast", {
      detail: { message, type: "warning" },
    })
  );
}

export function isDynamicImportLoadError(value) {
  const message = messageFromUnknown(value);
  if (!message) return false;
  if (CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message))) return true;

  return /\/assets\/[^/\s]+\.js(?:\?|$)/i.test(message);
}

export function handleDynamicImportLoadError(value) {
  if (typeof window === "undefined") return false;
  if (!isDynamicImportLoadError(value)) return false;

  const now = Date.now();
  const href = window.location.href;
  const lastReload = readLastReload();
  const alreadyRetried =
    lastReload?.href === href &&
    Number.isFinite(lastReload?.at) &&
    now - lastReload.at < CHUNK_RELOAD_RETRY_WINDOW_MS;

  if (alreadyRetried) {
    dispatchRecoveryToast(
      "The app could not load updated files. Please refresh the page, then sign in again if needed."
    );
    return true;
  }

  writeLastReload({ at: now, href });
  dispatchRecoveryToast("The app loaded updated files. Refreshing now...");

  window.setTimeout(() => {
    window.location.reload();
  }, 100);

  return true;
}
